import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M8 5h8v10H8z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 21h8v2H8zm8-19.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
})), 'DockTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DockTwoTone.js
// module id = 3222
// module chunks = 2